/**
 * FASE 1 — Campo de NACIONALIDADE (país).
 *
 * Texto com sugestões (`<datalist>`): o usuário digita "bra" e o navegador
 * sugere "Brasil", mas nada impede escrever outro país. Ao SAIR do campo o valor
 * é canonizado quando já existe na lista ("brasil" → "Brasil") e os espaços
 * sobrando são limpos — é o mesmo texto que vai para o servidor.
 */
import { useId } from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { PAISES, normalizarPais, NACIONALIDADE_PADRAO } from '../lib/paises';

export default function CampoPais({
  value,
  onChange,
  label = 'Nacionalidade',
  testId = 'pais',
  hint,
  className = '',
}) {
  const listaId = useId();

  return (
    <div className="space-y-1.5">
      {label && <Label className="text-[#A1A1AA] text-xs">{label}</Label>}
      <Input
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        // Ao sair do campo, padroniza a grafia com o que existe na lista.
        onBlur={() => onChange(normalizarPais(value))}
        list={listaId}
        placeholder={`Ex: ${NACIONALIDADE_PADRAO}`}
        data-testid={testId}
        className={`bg-[#1A1A1A] border-[#27272A] text-white ${className}`}
      />
      <datalist id={listaId} data-testid={`${testId}-lista`}>
        {PAISES.map((p) => <option key={p} value={p} />)}
      </datalist>
      {hint && <p className="text-micro text-[#71717A] leading-tight">{hint}</p>}
    </div>
  );
}
